<template>
	<footer id="site-footer" class="in-module" role="contentinfo" itemscope="itemscope" itemtype="http://schema.org/WPFooter">
    <a href="#app" class="pagetop">▲ pagetop</a>
    <div class="in-module wrap no-top no-bottom">
      <div class="max">
        <dl class="company">
          <dt>GWF ガードワークス</dt>
          <dd>〒264-0017 千葉県千葉市若葉区加曽利町1528-11</dd>
          <dd>電話番号 / 043-375-2190</dd>
          <dd>定休日 / 不定休<small>※出張作業のため作業ピットは不在が多いので、<br>まずはご連絡をお願いいたします。</small></dd>
        </dl>
        <nav>
          <ul class="menu">
            <li itemprop="name"><a itemprop="url" href="/">ホームページ</a></li>
            <li itemprop="name"><a itemprop="url" href="/security/">カーセキュリティ</a></li>
            <li itemprop="name"><a itemprop="url" href="/cate/car/">車種別情報</a></li>
            <li itemprop="name"><a itemprop="url" href="/guide/">ショップガイド</a></li>
            <li itemprop="name"><a itemprop="url" href="/blog/">ブログ</a></li>
            <li itemprop="name"><a itemprop="url" href="/contact/">お問い合わせ</a></li>
          </ul>
          <ul class="sns">
            <li>
              <a rel="noreferrer noopener" href="https://twitter.com/guardworks375" title="Follow on Twitter" target="_blank">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"/></svg>
              </a>
            </li>
            <li>
              <a rel="noreferrer noopener" href="https://www.facebook.com/guardworks" title="Follow on Facebook" target="_blank">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M80 299.3V512H196V299.3h86.5l18-97.8H196V166.9c0-51.7 20.3-71.5 72.7-71.5c16.3 0 29.4 .4 37 1.2V7.9C291.4 4 256.4 0 236.2 0C129.3 0 80 50.5 80 159.4v42.1H14v97.8H80z"/></svg>
              </a>
            </li>
            <li>
              <a rel="noreferrer noopener" href="https://www.instagram.com/guardworks.info/" title="Follow on Instagram" target="_blank">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"/></svg>
              </a>
            </li>
            <li>
              <a rel="noreferrer noopener" href="https://www.youtube.com/@guardworks" title="Follow on YouTube" target="_blank">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M549.7 124.1c-6.3-23.7-24.8-42.3-48.3-48.6C458.8 64 288 64 288 64S117.2 64 74.6 75.5c-23.5 6.3-42 24.9-48.3 48.6-11.4 42.9-11.4 132.3-11.4 132.3s0 89.4 11.4 132.3c6.3 23.7 24.8 41.5 48.3 47.8C117.2 448 288 448 288 448s170.8 0 213.4-11.5c23.5-6.3 42-24.2 48.3-47.8 11.4-42.9 11.4-132.3 11.4-132.3s0-89.4-11.4-132.3zm-317.5 213.5V175.2l142.7 81.2-142.7 81.2z"/></svg>
              </a>
            </li>
            <li>
              <a rel="noreferrer noopener" href="https://feedly.com/i/subscription/feed/https%3A%2F%2Fguard-works.com%2Ffeed" target="_blank" title="Follow on feedly">
                <svg xmlns="http://www.w3.org/2000/svg"><path d="M11.55.652a2.174 2.174 0 0 0-3.105 0L.64 8.6a2.274 2.274 0 0 0 0 3.163l5.57 5.673c.388.343.894.553 1.45.553h4.677a2.18 2.18 0 0 0 1.56-.659l5.462-5.562a2.272 2.272 0 0 0 0-3.163L11.551.652zm-.216 14.518l-.78.792a.31.31 0 0 1-.223.095h-.667a.313.313 0 0 1-.206-.08l-.795-.808a.325.325 0 0 1 0-.452l1.114-1.134a.309.309 0 0 1 .443 0l1.114 1.135a.324.324 0 0 1 0 .452zm0-4.759l-3.115 3.173a.312.312 0 0 1-.223.093H7.33a.313.313 0 0 1-.208-.078l-.793-.808a.326.326 0 0 1 0-.453l3.449-3.512a.31.31 0 0 1 .443 0l1.114 1.135a.322.322 0 0 1 0 .45zm0-4.756l-5.45 5.55a.31.31 0 0 1-.224.094h-.667a.311.311 0 0 1-.207-.078l-.794-.81a.323.323 0 0 1 0-.45l5.785-5.892a.31.31 0 0 1 .443 0l1.114 1.134a.324.324 0 0 1 0 .452z" /></svg>
              </a>
            </li>
          </ul>
          <small class="copy">Copyright &copy; {{ currentYear }} example All rights reserved.</small>
        </nav>
      </div>
    </div>
	</footer>
</template>

<style lang="scss" scoped>
@use "sass:color";
footer{
  background: color.scale(module.$border, $lightness: 30%);
  padding: 0 0 4rem;
  @media screen and (max-width: module.$phone){
    padding-bottom: 3.2rem;
  }
  .pagetop{
    color: color.scale(module.$border, $lightness: -75%);
    background: module.$border;
    display: block;
    text-align: center;
    padding: 1rem 0;
  }
  .max{
    padding: 4rem 0 0;
    display: grid;
    grid-template-columns: auto 1fr;
    gap: 4rem;
    @media screen and (max-width: module.$phone){
      grid-template-columns: 1fr;
      gap: 2rem;
      padding: 3.2rem 0 0;
    }
    > * {
      align-self: flex-start;
    }
    .company{
      line-height: 1.66;
      @media screen and (max-width: module.$phone){
        text-align: center;
      }
      dt{
        font-size: 1.12rem;
        font-weight: 700;
      }
      dd{
        small{
          font-size: .8rem;
          display: block;
        }
      }
    }
  }
  nav{
    .menu{
      max-width: 50rem;
      margin: 0 0 0 auto;
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      direction: rtl;
      flex-direction: row-reverse;
      @media screen and (max-width: module.$tab){
        grid-template-columns: repeat(2, 1fr);
      }
      @media screen and (max-width: module.$phone){
        gap: 2px;
        max-width: 100%;
        border-radius: .4rem;
        overflow: hidden;
      }
      li{
        font-size: .92rem;
        line-height: 1.66;
        text-align: right;
        @media screen and (max-width: module.$phone){
          text-align: center;
        }
        &:first-child{
          margin: 0;
        }
        a{
          @media screen and (max-width: module.$phone){
            display: block;
            font-size: 1rem;
            background: module.$white;
            padding: .8rem;
          }
          &:hover{
            text-decoration: underline;
          }
        }
      }
    }
    .sns{
      @include module.flex();
      align-items: center;
      justify-content: flex-end;
      margin: 1.6rem 0 0;
      @media screen and (max-width: module.$phone){
        justify-content: center;
        margin: 3.2rem 0 0;
      }
      li{
        margin: 0 0 0 .4rem;
        &:first-child{
          margin-left: 0;
        }
        a{
          background: module.$normal;
          width: 2.4rem;
          height: 2.4rem;
          @include module.flex();
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          margin: 0 .64rem 0 0;
          transition: all 200ms module.$ease;
          &:last-of-type{
            margin: 0;
          }
          svg{
            display: block;
            fill: module.$border;
            width: .8rem;
            height: .8rem;
            transition: all 200ms module.$ease;
          }
          &:hover{
            background: module.$base;
            transform: scale(1.2);
            svg{
              transform: scale(.9);
              fill: module.$white;
            }
          }
        }
      }
    }
    small.copy{
      display: block;
      text-align: right;
      font-size: .72rem;
      margin: 1.6rem 0 0;
      @media screen and (max-width: module.$phone){
        text-align: center;
      }
    }
  }
}
</style>

<script>
export default {
	data() {
		return {
			currentYear: new Date().getFullYear()
		}
	}
}
</script>